export default {
	/** @override */
	teamingPackage: "",
	computed: {
		langns() {
			const { name, teamingPackage, } = this.$options;
			if ( !teamingPackage ) {
				return "";
			}
			const [ packageName, subPackageName = "components", ] = teamingPackage.split( "." );
			return `${ packageName }.${ subPackageName }.${ name }`;
		},
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			const { langns, } = this;
			if ( !langns ) {
				// eslint-disable-next-line no-console
				return console.error( `cannot translate ${ key } for component ${ name }: missing teamingPackage property` );
			}
			return this.$t( `${ langns }.${ key }`, args );
		},
	},
};
